<div class="floating-preview" [ngStyle]="panelStyle" role="dialog" [attr.aria-label]="fileName">
  <header class="floating-preview__header" (mousedown)="onHeaderMouseDown($event)">
    <span class="floating-preview__drag-handle" aria-hidden="true">
      <mat-icon>drag_indicator</mat-icon>
    </span>
    <span class="floating-preview__title" [title]="fileName">{{ fileName }}</span>
    <div class="floating-preview__window-actions">
      <button
        type="button"
        class="floating-preview__action"
        *ngIf="!isMinimized"
        (click)="minimize()"
        aria-label="Minimize preview"
      >
        <mat-icon>remove</mat-icon>
      </button>
      <button
        type="button"
        class="floating-preview__action"
        *ngIf="isMinimized"
        (click)="restore()"
        aria-label="Restore preview"
      >
        <mat-icon>open_in_full</mat-icon>
      </button>
      <button
        type="button"
        class="floating-preview__action"
        *ngIf="!isMinimized"
        (click)="toggleMaximize()"
        [attr.aria-label]="isMaximized ? 'Restore window size' : 'Maximize preview'"
      >
        <mat-icon>{{ isMaximized ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
      </button>
      <button
        type="button"
        class="floating-preview__action floating-preview__action--close"
        (click)="close()"
        aria-label="Close preview"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="floating-preview__toolbar" *ngIf="!isMinimized">
    <button type="button" class="floating-preview__toolbar-btn" (click)="download()">
      <mat-icon>download</mat-icon>
      Download
    </button>
  </div>

  <div class="floating-preview__body" *ngIf="!isMinimized">
    <img
      *ngIf="kind === 'image'"
      class="floating-preview__image"
      [src]="imagePreviewUrl"
      [alt]="fileName"
    />

    <p *ngIf="kind === 'pdf' && isLoadingPdf" class="floating-preview__status">
      Loading PDF preview…
    </p>

    <iframe
      *ngIf="kind === 'pdf' && safePdfUrl && !isLoadingPdf"
      class="floating-preview__frame"
      [src]="safePdfUrl"
      [title]="fileName"
    ></iframe>

    <p
      *ngIf="kind === 'pdf' && pdfLoadFailed && !isLoadingPdf"
      class="floating-preview__status floating-preview__status--error"
    >
      Unable to load PDF preview.
    </p>

    <div *ngIf="kind === 'json'" class="floating-preview__json-wrap">
      <p *ngIf="isLoadingJson" class="floating-preview__status">Loading preview…</p>
      <p *ngIf="jsonLoadFailed" class="floating-preview__status floating-preview__status--error">
        Unable to load JSON preview.
      </p>
      <pre *ngIf="!isLoadingJson && !jsonLoadFailed" class="floating-preview__json">{{ jsonPreview }}</pre>
    </div>

    <p *ngIf="kind === 'unsupported'" class="floating-preview__status">
      Preview is not available for this file type.
    </p>
  </div>

  <div
    class="floating-preview__resize floating-preview__resize--left"
    *ngIf="!isMinimized && !isMaximized"
    (mousedown)="onResizeMouseDown('left', $event)"
  ></div>
  <div
    class="floating-preview__resize floating-preview__resize--right"
    *ngIf="!isMinimized && !isMaximized"
    (mousedown)="onResizeMouseDown('right', $event)"
  ></div>
  <div
    class="floating-preview__resize floating-preview__resize--bottom"
    *ngIf="!isMinimized && !isMaximized"
    (mousedown)="onResizeMouseDown('bottom', $event)"
  ></div>
  <div
    class="floating-preview__resize floating-preview__resize--corner-bl"
    *ngIf="!isMinimized && !isMaximized"
    (mousedown)="onResizeMouseDown('corner-bl', $event)"
  ></div>
  <div
    class="floating-preview__resize floating-preview__resize--corner-br"
    *ngIf="!isMinimized && !isMaximized"
    (mousedown)="onResizeMouseDown('corner-br', $event)"
  ></div>
</div>
